import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { cls } from '@mssgme/helpers';
import Spinner from '../Spinner';
import useLoadImage from './useLoadImage';
import useIntersect from './useIntersect';
import Thumbnail from './Thumbnail';

import styles from './LazyImage.scss';

export default function LazyImage({ mode, src, alt, containerClassName, ...rest }) {
    const { ref, isIntersecting, isIntersect } = useIntersect();
    const { isFetching, isLoaded, onLoad, onError, error } = useLoadImage();

    return (
        <div ref={ref} className={classNames(styles.root, styles[mode], containerClassName)}>
            {isFetching && mode !== 'inline' && <Spinner size="50%" color="gray" className={styles.spinner} />}
            {error && <Thumbnail />}
            <img
                src={isIntersect ? src : null}
                alt={alt}
                onLoad={onLoad}
                onError={onError}
                {...cls([styles.img, isLoaded && isIntersecting && styles.visible], rest)}
            />
        </div>
    );
}

LazyImage.propTypes = {
    className: PropTypes.string,
    containerClassName: PropTypes.string,
    mode: PropTypes.oneOf(['fit', 'inline']),
    src: PropTypes.string.isRequired,
    alt: PropTypes.string,
};

LazyImage.defaultProps = {
    mode: 'fit',
};
